import React from "react";
import { t, businessName, itemName, customerMobile } from "./invoiceTemplate.shared";
import { InvoiceBrandMark, InvoiceSignature } from "./InvoiceBrandAssets";
import "./ServiceInvoiceTemplate.css";

const ServiceInvoiceTemplate = ({
  invoice,
  invoiceNumber,
  businessSnapshot,
  customerName,
  customerSnapshot,
  billingAddress,
  shippingAddress,
  calculatedItems = [],
  totals = {},
  grandTotal = 0,
  paidAmount = 0,
  balanceAmount = 0,
  displayCurrency,
  formatAddress,
  formatDate,
  formatLabel,
  formatNumber,
  numberToWords,
}) => (
  <section className="invoice-service">
    <header><div className="invoice-template-brand-block"><InvoiceBrandMark businessSnapshot={businessSnapshot} /><div><small>SERVICE INVOICE</small><h1>{businessName(businessSnapshot)}</h1><p>{formatAddress(businessSnapshot?.address || businessSnapshot)}</p></div></div><aside><span>Invoice</span><b>{invoiceNumber}</b><span>{formatDate(invoice?.documentDate)}</span></aside></header>
    <div className="invoice-service__client"><div><small>SERVICE CUSTOMER</small><b>{customerName}</b><p>{formatAddress(billingAddress)}</p></div><div><small>CONTACT</small><b>{customerMobile(customerSnapshot, invoice)}</b><p>{t(customerSnapshot?.email)}</p></div><div><small>REFERENCE</small><b>{t(invoice?.referenceNumber)}</b></div></div>
    <h3 className="invoice-service__section">Services / Work Performed</h3>
    <table><thead><tr><th>#</th><th>Service / Description</th><th>HSN/SAC</th><th>Qty</th><th>Rate</th><th>Taxable</th><th>Amount</th></tr></thead><tbody>{calculatedItems.map((item,index)=><tr key={item?._id || index}><td>{index+1}</td><td><b>{itemName(item)}</b><small>{item?.description || "Service / work item"}</small></td><td>{t(item?.hsnSacCode)}</td><td>{formatNumber(item?.calculation?.quantity,0,2)}</td><td>{displayCurrency(item?.calculation?.rate)}</td><td>{displayCurrency(item?.calculation?.taxableAmount)}</td><td><b>{displayCurrency(item?.calculation?.totalAmount)}</b></td></tr>)}</tbody></table>
    <div className="invoice-service__bottom"><div><h3>Service Notes</h3><p>{invoice?.customerNotes || "Please retain this invoice for warranty and service reference."}</p><h3>Terms & Conditions</h3><p>{invoice?.termsAndConditions || "Service completion and warranty are subject to the agreed scope of work."}</p><small>AMOUNT IN WORDS</small><b>Indian Rupees {numberToWords(grandTotal)} Only</b></div><aside><span>Taxable <b>{displayCurrency(totals?.taxableAmount || 0)}</b></span><span className="grand">Grand Total <b>{displayCurrency(grandTotal)}</b></span><span>Paid <b>{displayCurrency(paidAmount)}</b></span><span className="due">Balance <b>{displayCurrency(balanceAmount)}</b></span></aside></div>
    <InvoiceSignature businessSnapshot={businessSnapshot} />
  </section>
);

export default ServiceInvoiceTemplate;
